import request from '../utils/request'

/**
 * 创建角色
 */
export function createRole(data) {
  return request({
    url: '/admin/sys-role',
    method: 'post',
    data
  })
}

/**
 * 更新角色
 */
export function updateRole(data) {
  return request({
    url: '/admin/sys-role',
    method: 'put',
    data
  })
}

/**
 * 删除角色
 */
export function deleteRole(id) {
  return request({
    url: `/admin/sys-role/${id}`,
    method: 'delete'
  })
}

/**
 * 根据ID获取角色
 */
export function getRoleById(id) {
  return request({
    url: `/admin/sys-role/${id}`,
    method: 'get'
  })
}

/**
 * 分页查询角色列表
 */
export function getRoleList(params) {
  return request({
    url: '/admin/sys-role/list',
    method: 'get',
    params
  })
}

/**
 * 获取所有角色列表（用于角色管理页面）
 */
export function getAllRoles() {
  return request({
    url: '/admin/sys-role/all',
    method: 'get'
  })
}

/**
 * 获取角色列表用于下拉框选择（用于账户管理页面等，检查账户管理菜单权限）
 */
export function getRoleOptions() {
  return request({
    url: '/admin/sys-role/options',
    method: 'get'
  })
}

/**
 * 分配菜单给角色
 */
export function assignMenus(roleId, menuIds) {
  return request({
    url: `/admin/sys-role/${roleId}/menus`,
    method: 'post',
    data: menuIds
  })
}

/**
 * 分配权限给角色
 */
export function assignPermissions(roleId, permissionIds) {
  return request({
    url: `/admin/sys-role/${roleId}/permissions`,
    method: 'post',
    data: permissionIds
  })
}

